// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 897 ? "sentry" : chunkId) + ".legacy." + {"101":"a62bae939005c0ee9659","897":"8a5386555f212a5762d1"}[chunkId] + ".js";
};